export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const LOADING_STARTED = 'LOADING_STARTED'
export const LOADING_STOPPED = 'LOADING_STOPPED'
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS'

export const TODO_SEARCH_REQUEST = 'TODO_SEARCH_REQUEST'
export const TODO_SEARCH_RESULTS = 'TODO_SEARCH_RESULTS'
export const TODO_CLEAR_DATA = 'TODO_CLEAR_DATA'

export const NAVIGATE_TO_PROCESS_START = 'NAVIGATE_TO_PROCESS_START'
export const NAVIGATE_TO_PAYCHARGES = 'NAVIGATE_TO_PAYCHARGES'
export const NAVIGATE_TO_SEARCH = 'NAVIGATE_TO_SEARCH'

export const DND_WHAT_IF = 'DND_WHAT_IF'
export const DND_CONFIRM = 'DND_CONFIRM'

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const START_PAYMENT_SUCCESS = 'START_PAYMENT_SUCCESS'
export const SHOW_SEE_YOU_LATER = 'SHOW_SEE_YOU_LATER'
export const PAYMENT_CLEARED = 'PAYMENT_CLEARED'
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE'

export const DOWNTIME_DATES = 'DOWNTIME_DATES'

export const SET_MOC_CHECK_RESPONSE = 'SET_MOC_CHECK_RESPONSE'